import React from 'react';
import '../assets/css/loading.css';

const LoadingSpinner = ({ message = 'Loading...' }) => {
  return (
    <div className="evd-loading-spinner">
      <div className="evd-spinner-container">
        <div className="evd-spinner">
          <img src="/images/favicon.png" alt="EVD Logo" className="evd-spinner-logo" />
        </div>
        <p className="evd-spinner-text">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
